import { Component, inject } from '@angular/core';
import { AdminSupplierDetails } from '../../../../components/admin-dashboard-component/admin-suppliers-component/admin-supplier-details/admin-supplier-details';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-get-supplier',
  imports: [AdminSupplierDetails],
  templateUrl: './admin-get-supplier.html',
  styleUrl: './admin-get-supplier.scss',
})
export class AdminGetSupplier {
  private route = inject(ActivatedRoute);
  supplierId = this.route.snapshot.paramMap.get('id');
}
